import Moment from 'react-moment';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import { fetchBriefestEventParticipationByContactId, fetchEventById } from '../../Service/restapi/eventService';
import { getKindDescription } from '../../Service/helper/EventService';

export const ChatMessageEventRelation = ({ history, profileContactId, emailToId, emailFromId, eventId, style }) => {
  const navigate = useNavigate();
  const [event, setEvent] = useState(undefined);

  useEffect(() => {
    // ! on selecting other email, delete event of previous selected email !
    setEvent(undefined);

    if (profileContactId && emailToId && emailFromId) {
      const customerId = profileContactId === emailToId ? emailFromId : emailToId;

      if (!eventId) {
        fetchEventParticipation(customerId);
      } else {
        fetchEventById(eventId)
          .then((resp) => {
            if (resp.ok) {
              resp.json().then((event) => {
                setEvent(event);
              });
            } else {
              console.info(`could not load event ${eventId}`);
            }
          })
          .catch(() => {
            console.info(`could not load event ${eventId}`);
          });
      }
    } else {
      new Error('ToId of Email is null');
    }
  }, [profileContactId, emailToId, emailFromId, eventId]);

  if (window.location.pathname.includes('/events')) {
    return null;
  }

  function fetchEventParticipation(customerId) {
    // ask event service for participating in next or last event
    fetchBriefestEventParticipationByContactId(customerId, true)
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((participations) => {
            if (participations.length > 0) {
              console.log(`got ${participations.length} participations for contact ${customerId}`);
              const { eventId } = participations[0];
              fetchEventById(eventId)
                .then((resp) => {
                  if (resp.ok) {
                    resp.json().then((event) => {
                      setEvent(event);
                    });
                  } else {
                    console.info(`could not load event ${document.eventId}`);
                  }
                })
                .catch(() => {
                  console.info(`could not load event ${document.eventId}`);
                });
            } else {
              console.log(`no event participations found for contact ${customerId}`);
              setEvent(undefined);
            }
          });
        } else {
          console.error(`could not load event participations of contact ${customerId}`);
          setEvent(undefined);
        }
      })
      .catch((error) => {
        console.error(`could not load event participations of contact ${customerId}`);
        console.error({ error });
        setEvent(undefined);
      });
  }

  if (!event) return null;

  const styles = {
    dateContainer: {
      fontSize: 11,
    },
    button: {
      color: '#698aa6',
      fontWeight: 800,
      fontFamily: 'Nunito Sans',
    },
  };

  return (
    <div style={style}>
      <Button
        type="button"
        className="icon-and-text clickable"
        style={styles.button}
        onClick={() => {
          navigate(`/events/${event.id}/details`);
        }}
        color=""
      >
        <div style={styles.dateContainer}>
          <span style={{ alignSelf: 'flex-end' }}>{getKindDescription(event.kind)}</span>
          <Moment format="DD.MM.YYYY">{event.dates[0].date}</Moment>
        </div>
      </Button>
    </div>
  );
};
